export async function loadPolyfills() {
  if ('ResizeObserver' in window === false) {
    const module = await import('@juggle/resize-observer');
    (window as any).ResizeObserver = module.ResizeObserver;
  }
}
